const constsMeta = {
  REACT_APP_NATIVE_APP: 'false',
  REACT_APP_TEST_ENV: 'false',
  REACT_APP_REST_SERVER: 'https://staging-zapier.yuvidio.com:2096',
  REACT_APP_N1_SERVER: 'https://staging-zapier.yuvidio.com:2053',
  REACT_APP_P1_SERVER: 'https://staging-zapier.yuvidio.com:2053',
  REACT_APP_WS_SERVER: 'wss://ws.yuvidio.com',
  REACT_APP_GOOGLE_IOS_ID: null,
  REACT_APP_GOOGLE_ANDROID_WEB_CLIENT_ID: null,
  REACT_APP_GOOGLE_ANDROID_CLIENT_ID: null,
  REACT_APP_ONE_SIGNAL_APP_ID: '83e12efc-ad41-4d12-b17d-2c0fa95b4274',
  REACT_APP_FACEBOOK_APP_ID: null,
  REACT_APP_CLIENT_PAGE: null,
  REACT_APP_MINOR_APPVERSION: null,
  REACT_APP_MAJOR_APPVERSION: null,
  REACT_APP_EXPERT_PAGE: null,
  REACT_APP_STRIPE_PUBLISHABLE_KEY: null,
  REACT_APP_STRIPE_C2C_PUBLISHABLE_KEY: null,
  REACT_APP_STRIPE_C2C_CLIENT_ID: null,
  REACT_APP_DESKTOP_APP: window?.electron ? true : false,
};

export default constsMeta;
